<jf-form-wrapper
  [buttons]="!angewiesen ? formActionsButtons : undefined"
  [title]="!angewiesen ? 'Überweisung erstellen' : 'Überweisung angewiesen'"
>
  <ng-container header>
    <div *ngIf="isNotEditable" class="state-description">
      <div class="icon-wrapper">
        <jf-icon
          [name]="'editDisabled'"
          [size]="20"
        ></jf-icon>
      </div>
      <p>
        Diese Überweisung ist nicht bearbeitbar. Sie wurde in ADNOVA+ erstellt und kann nur dort verändert werden.
      </p>
    </div>

    <div *ngIf="isBelegCancelled && !angewiesen" class="state-description">
      <div class="icon-wrapper">
        <jf-icon
          [name]="'editDisabled'"
          [size]="20"
        ></jf-icon>
      </div>
      <p>
        Dieser Beleg wurde storniert. Bitte wähle, ob der Beleg neu zugeordnet oder die Zahlung gelöscht werden soll.
      </p>
    </div>
  </ng-container>
  <ng-container content>
    <zlng-form-block-payment-data
    ></zlng-form-block-payment-data>
  </ng-container>
</jf-form-wrapper>
